import { QuestionBase } from './question-base';

export class StateSelectorQuestion extends QuestionBase<string> {
    override controlType = 'state-selector';
}
